import { render, staticRenderFns } from "./PSDPreview.vue?vue&type=template&id=ab49caa4&scoped=true"
import script from "./PSDPreview.vue?vue&type=script&lang=js"
export * from "./PSDPreview.vue?vue&type=script&lang=js"
import style0 from "./PSDPreview.vue?vue&type=style&index=0&id=ab49caa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab49caa4",
  null
  
)

export default component.exports